export default "__VITE_ASSET__BEOcMYE6__"